<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { useCssClass } from "@/composables/reactive/useCssClass";

const { t } = useI18n();
const props = withDefaults(
  defineProps<{
    orderId: string;
    orderNumber?: number;
    customClass?: string | Record<string, boolean>;
    hideLabel?: boolean;
  }>(),
  {
    orderNumber: 0,
    customClass: "",
    hideLabel: false,
  },
);

const { cssClass } = useCssClass(props.customClass, "text-primary");
</script>

<template>
  <router-link
    :class="cssClass"
    :to="{ name: 'order-view', params: { id: props.orderId } }"
    class="text-decoration-none font-weight-500"
    data-qa="route-order-number"
    target="_blank"
  >
    <span> {{ props.hideLabel ? "" : t("general.order") }}#{{ props.orderNumber || props.orderId }} </span>
  </router-link>
</template>
